var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropzone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 262,
    viewBox: "0 0 246 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 245,
    height: 261,
    rx: 9.5,
    stroke: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzone);
export default __webpack_public_path__ + "static/media/dropzone.4df8eb4d27619ba08b779988ba747dc6.svg";
export { ForwardRef as ReactComponent };